export class ProviderBio {
    isLCSW:boolean;
    specialty: string;
    providerUserId: string;
    providerBio: string;
    name: string;
    avatarBase64: string;
    
}
export class BoardCertification {
    credentialId: string;
    nameOfCertifyingBoard: string;
    specialty: string;
    effectiveDate: string;
}

export class CredentialsEducation {
    credentialId: string;
    additionalTraining: string;
    professionalMembership: string;
    yearsInPractice: string;
    populationServed: string;
    areasOfKnowledge: string;
    nationalCertifications: string;
}

export class TherapeuticOrientation {
    credentialId: string;
    therapeuticOrientationState: string;
}

export class StateLicens {
    state: string;
    licenseNumber: string;
    id: string;
    providerProfileID: string;
    providerType: string;
    licenseType: string;
    dateSubmitted: string;
    validFrom: string;
    validUntil: string;
    taxonomyID?: any;
    dateCreated: string;
    createdBy: string;
    updatedDate: string;
    updatedBy?: number;
    dateEdited: string;
    editedBy: string;
    deleted: string;
    dateDeleted?: Date;
    deletedBy?: number;
    isActive: string;
    priority: string;
}
export class NationalCertifications {
    NameOfCertifyingBoard: string;
    Specialty: string;
    IssueDate: string;
    ExpirationDate: string;
}


export class ProviderBioFullDetail {
    specialty: string;
    providerUserId: string;
    providerBio?: any;
    name: string;
    avatarBase64: string;
    boardCertifications: BoardCertification[];
    credentialsEducation: CredentialsEducation[];
    therapeuticOrientation: TherapeuticOrientation[];
    stateLicenses: StateLicens[];
    nationalCertifications: NationalCertifications[];
}